import { CommunicationModel } from "./comunication.model"

export class InappModel extends CommunicationModel {
  emojis: string[]
  constructor(obj: any = null) {
    super(obj)
    this.emojis = obj?.emojis || []
  }
}
